import {AfterViewInit, Component, Input, OnInit, Output} from '@angular/core';
import {EventEmitter} from '@node_modules/@angular/core';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss']
})
export class TimeInputComponent implements OnInit, AfterViewInit {
  @Input() index: number;
  @Input() hours = '';
  @Input() timePart = 'AM';
  @Input() minutes = '';
  @Output() timeEmitter = new EventEmitter<string>();
  time: {
    hours: string,
    minutes: string,
  } = {
    hours: null,
    minutes: null,
  };
  constructor() { }

  ngOnInit() {
    this.time.hours = this.hours;
    this.time.minutes = this.minutes;
  }
  ngAfterViewInit() {
    // this.setTime.subscribe(
    //   (resp: { hours: string, minutes: string, index: number}) => {
    //     console.log(resp);
    //     console.log(this.index);
    //     if (resp && resp.index === this.index) {
    //       console.log(resp);
    //       if (resp.hours) {
    //         this.hours = resp.hours;
    //         this.onChangeTime({data: resp.hours}, true, true)
    //       }
    //       if (resp.minutes) {
    //         this.minutes = resp.minutes;
    //         this.onChangeTime({data: resp.minutes}, false, true)
    //       }
    //     }
    //   }
    // )
  }
  onBlurInput(event, isHours = false) {
    console.log(event.target.value);
    if (event.target.value && event.target.value.length === 1) {
      event.target.value = '0' + event.target.value;
      isHours === true ? this.time.hours = event.target.value : this.time.minutes = event.target.value;
      this.emitTime();
    }
    Array.from(event.target.closest('div').getElementsByTagName('input')).forEach((input: HTMLInputElement) => {
      if (!input.value || input.value.length === 0) {
        input.value = '00';
        this.time.minutes = '00';
        this.emitTime();
      }
    });
  }
  onChangeTime(time, isHours = false, init = false) {
    console.log(time.target.value);
    if ((time.keyCode >= 48 && time.keyCode <= 57) ||
      (time.keyCode >= 96 && time.keyCode <= 105) ||
      (time.keyCode >= 37 &&  time.keyCode <= 40) ||
      time.keyCode === 9 ||
      time.keyCode === 8 ||
      time.keyCode === 46) {
      if (time.keyCode !==  8  &&  time.keyCode !== 46 &&
        time.keyCode !== 37 &&
      time.keyCode !== 38 &&
      time.keyCode !== 39 &&
      time.keyCode !== 40 &&
      time.keyCode !== 9) {
        let input = time.target.value + time.key;
        // console.log(time.target.value);
        // console.log(time.key);
        // console.log(input);
        const value = input.length === 2 ? input.slice(0, -1) : '';
          // console.log(value);
        //   value = (!value || value.length === 0) && time.data && time.data.length === 2 ?  time.data.slice(0, -1) : value;
        // console.log(value);
        if (input.length <= 2) {
          // console.log(input);
          let newVal = this.validateTime(input);
          newVal = newVal !== 0 && newVal.toString().length === 1 ? value + newVal : newVal + '';
          // console.log(newVal);
          // console.log(Number.parseInt(newVal + ''));
          if (Number.parseInt(newVal + '') > 12 && isHours === true) {
            console.log(input);
            input = '12';
          } else if (Number.parseInt(newVal + '') > 59 && isHours === false) {
            input = '59';
          } else if ((newVal + '').length === 0) {
            input = '';
          } else {
            input = input === '00' ? '00' : newVal;
          }
        } else if ((time.keyCode >= 48 && time.keyCode <= 57) || (time.keyCode >= 96 && time.keyCode <= 105)){
          input = time.key;
        } else {
          input = '';
        }
        time.target.value = '';
        setTimeout(() => {
          // console.log(input);
          time.target.value = input;
        }, 0);
        // if (isHours === true) {
        //   time.target.value = input;
        // } else {
        //   this.minutes = input;
        // }

        // console.log(input);
        // console.log(this.hours);

        isHours === true ? this.time.hours = input + '' : this.time.minutes = input + '';
        if (init === false) {
          this.emitTime();
        }
        return false;
      }
    } else {
      return false;
    }
  }
  onChangeTimePart() {
    this.timePart = this.timePart === 'AM' ? 'PM' : 'AM';
    this.emitTime();
  }
  private validateTime(time) {
    // console.log(time);
    const timeConverted = time === '0' ? 0 : Number.parseInt(time);
    return isNaN(timeConverted) ? '' : timeConverted;
  }
  private emitTime() {
    // console.log(this.time);
    if (this.time && this.time.hours && this.time.hours.length === 2 && this.time.minutes && this.time.minutes.length === 2) {
      this.timeEmitter.emit(this.time.hours + ':' + this.time.minutes + ' ' + this.timePart);
    } else {
      this.timeEmitter.emit('');
    }
  }
}
